/*
 * @Author: libo 
 * @Date: 2020-11-19 10:58:20 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:50:11
 */

<template>
    <a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel"
                :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
        <template>
          <a-card style="" :bordered="true" :title="$t('数据详情')">
            <detail-list>
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):$t('未知')}}</detail-list-item>
              <detail-list-item :term="$t('阀门状态')">
                {{ $t(Mn100FkStatusObj[model.meterValveStatus] || '') }}
              </detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
              <detail-list-item :term="$t('故障描述')">{{model.meterWarnDetail}}</detail-list-item>
              <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
            </detail-list>
          </a-card>
          <a-form-model ref="formModel" :model="formModel" :rules="rules" :colon="false">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item :label="$t('处理描述')">
                  <a-textarea v-model="formModel.remark" :placeholder="$t('请输入处理描述')" :rows="3" style="width:100%;"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="7">
              </a-col>
              <a-col :span="8">
                <h4 style="font-weight: bold;">{{ $t('请选择处理状态') }}:</h4>
                <a-select  v-model="formModel.meterDealStatus" :placeholder="$t('请选择处理状态')">
                  <a-select-option :value="0">
                    {{ $t('未处理') }}
                  </a-select-option>
                  <a-select-option :value="1">
                    {{ $t('处理中') }}
                  </a-select-option>
                  <a-select-option :value="2">
                    {{ $t('已处理') }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>
          </a-form-model>
        </template>
    </a-modal>
</template>
<script>
  import { httpAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterReadingAbnormalModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:'',
        modalWidth:900,
        Mn100FkStatusObj,
        visible: false,
        confirmLoading: false,
        model: {},
        formModel: {},
        rules:{
        },
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "jeecg-charge/meter/meterUpFaultRecord/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
        },
        meterTypeObj,
      }
    },
    computed:{
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
    },
    methods: {
      edit(record) {
        this.visible = true;
        this.model = Object.assign({}, record)
        this.formModel = Object.assign({}, record)
        console.log(this.model);
        // this.formModel.meterDealStatus = record.meterDealStatus
      },
      handleSubmit () {
        let params = Object.assign({},this.model)
        params.meterDealStatus = this.formModel.meterDealStatus
        if (this.formModel.meterDealStatus == 0) {
          params.meterDealDescription0 = this.formModel.remark
        } if (this.formModel.meterDealStatus == 1) {
          params.meterDealDescription1 = this.formModel.remark
        } if (this.formModel.meterDealStatus == 2) {
          params.meterDealDescription2 = this.formModel.remark
        }
        console.log("处理提交数据",params)
        const that = this
        httpAction(this.url.edit, params, 'put').then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            setTimeout(() => {
              that.$emit('ok');
            },400)
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
          this.searchReset();
        })
        this.handleCancel();
      },
      handleCancel() {
        this.close();
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      searchReset() { //重置
        this.formModel = {}
      },
    }
  }
</script>

<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
</style>